"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyMyPurchasesTab = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsSpots = require("@olxbr/ds-spots");
var _ScreenPlaceholder = require("../../molecules/ScreenPlaceholder");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var EmptyMyPurchasesTab = exports.EmptyMyPurchasesTab = function EmptyMyPurchasesTab() {
  var REACT_APP_LISTING_URL = "https://www.olx.com.br/brasil";
  var handleCTAClick = function handleCTAClick() {
    window.open(REACT_APP_LISTING_URL, '_blank');
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenPlaceholder.ScreenPlaceholder, {
    spot: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsSpots.Chat, {
      shape: "triangle"
    }),
    title: "Voc\xEA n\xE3o tem nenhuma negocia\xE7\xE3o de compra ativa",
    text: "A OLX tem os melhores usados pelos melhores pre\xE7os!",
    cta: 'Quero comprar!',
    action: handleCTAClick
  });
};